import React, { useEffect, useState } from 'react';
import { Input, Card, Button, List, Typography, Space, Tag, Empty } from 'antd';
import { CheckCircleFilled, BuildOutlined } from '@ant-design/icons';
import { t } from '../../i18n/i18n';
import Spinner from '../spinner/Spinner';
import './ResetTestgroupStep1.scss';

const { Title, Text } = Typography;
const { Search } = Input;

const ResetTestgroupStep1 = ({
  companies,
  fetchCompanies,
  loading,
  selectedCompany,
  handleSelectCompany,
  handleNextStep,
}) => {
  const [search, setSearch] = useState('');

  useEffect(() => {
    fetchCompanies({ search });
  }, []);

  return (
    <div className="reset-step-container modern-step">
      <div className="step-header">
        <Title level={3} className="step-title">
          <BuildOutlined className="step-icon" />
          {t('RESET_TESTGROUP_STEP_1_TITLE')}
        </Title>
      </div>

      <div className="step-content">
        <div className="search-section">
          <Search
            placeholder={t('RESET_TESTGROUP_STEP_1_SEARCH_PLACEHOLDER')}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onSearch={(value) => fetchCompanies({ search: value })}
            className="modern-search"
            size="large"
          />
        </div>

        <div className="companies-selection-area">
          {loading ? (
            <div className="loading-container">
              <Spinner show />
            </div>
          ) : companies?.collection?.length > 0 ? (
            <List
              className="companies-list"
              dataSource={companies.collection}
              renderItem={(company) => (
                <List.Item className="company-item">
                  <Card
                    hoverable
                    onClick={() => handleSelectCompany(company.id)}
                    className={`company-card ${selectedCompany === company.id ? 'selected-card' : ''}`}
                    size="small"
                  >
                    <div className="company-content">
                      <Space className="w-100 justify-content-between align-items-center">
                        <div className="company-info">
                          <Text strong className="company-name">{company.displayName}</Text>
                        </div>
                        {selectedCompany === company.id && (
                          <CheckCircleFilled className="check-icon-company" />
                        )}
                      </Space>
                    </div>
                  </Card>
                </List.Item>
              )}
            />
          ) : (
            <Empty
              description={t('NO_COMPANIES_FOUND')}
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              className="empty-state"
            />
          )}
        </div>
      </div>

      <div className="step-footer">
        <Button
          type="primary"
          size="large"
          onClick={handleNextStep}
          disabled={!selectedCompany}
          className="next-step-btn"
        >
          {t('RESET_TESTGROUP_NEXT_BUTTON')}
        </Button>
      </div>
    </div>
  );
};

export default ResetTestgroupStep1;
